import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ReusableService } from '@services/reusable.service';
import { NgxMasonryComponent, NgxMasonryModule } from 'ngx-masonry';
import { EditableCardComponent } from '@components/cards/editable-card/editable-card.component';
import equations from './question-equation.json';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-question-tile',
  templateUrl: './question-tile.component.html',
  styleUrls: ['./question-tile.component.scss'],
  standalone: true,
  imports: [EditableCardComponent, NgxMasonryModule]
})
export class QuestionTilesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data;
  @Output() reload = new EventEmitter<void>();
  rid: string;
  sections: any[] = [];
  showOnlyGridFlag = true;
  private readonly destroy$ = new Subject<void>();

  constructor(private reusableService: ReusableService) {}

  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  ngOnInit(): void {
    this.reusableService.showhpdcTiles.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.showOnlyGridFlag = !data;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(): void {
    if (!this.data) return;
    this.rid = this.data.requestRid;
    this.init(this.data.questions);
  }

  init(questionsData) {
    const hasEquations = !!equations;
    questionsData.forEach((element) => {
      element.targetRid = this.rid;
      element.isQuestions = true;

      const elementEquations = hasEquations ? equations[element.name]?.equation : null;
      const isReadOnly = !element.actions?.edit;

      element.formSchema.forEach((form) => {
        delete form.subsection;
        if (form.formtype !== 'display_only' && isReadOnly) {
          form.formtype = 'disabled';
          form.defaultValue = null;
        }

        if (elementEquations) {
          form.equations = elementEquations.find((e) => e.key === form.key);
        }
      });
      this.reusableService.pradicateBy(questionsData, 'sortlevel');
      this.sections = questionsData;
      setTimeout(() => this.reloadMasonryLayout(), 50);
    });
  }

  reloadMasonryLayout(): void {
    if (this.masonry) {
      this.masonry.reloadItems();
      this.masonry.layout();
    }
  }

  reloadCardData() {
    this.reload.emit();
  }
}
